// src/components/financeOfficer/ViewRequisitionModal.jsx

import React from "react";
import { FaUser, FaTag, FaDollarSign, FaBuilding, FaInfoCircle, FaCalendarAlt } from "react-icons/fa";

const ViewRequisitionModal = ({ requisition, isOpen, onClose }) => {
    if (!isOpen || !requisition) return null;

    const modalClasses = "fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 transition-opacity duration-300";

    return (
        <div className={modalClasses}>
            <div
                className="bg-white p-8 rounded-lg shadow-lg max-h-[90vh] overflow-y-auto w-full max-w-xl relative"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="flex justify-between items-center mb-4 border-b pb-2">
                    <h3 className="text-2xl font-bold text-gray-800">Requisition Details</h3>
                    <button onClick={onClose} className="text-gray-500 hover:text-gray-700 text-2xl">&times;</button>
                </div>

                <div className="space-y-4 text-gray-700">
                    <div className="flex items-center gap-3">
                        <FaUser className="text-orange-500" />
                        <span className="font-semibold">Officer:</span>
                        <span>
                            {requisition.officer ? `${requisition.officer.firstName} ${requisition.officer.lastName}` : "N/A"}
                        </span>
                    </div>

                    <div className="flex items-center gap-3">
                        <FaTag className="text-orange-500" />
                        <span className="font-semibold">Items:</span>
                        <span>{requisition.items}</span>
                    </div>

                    <div className="flex items-center gap-3">
                        <FaDollarSign className="text-orange-500" />
                        <span className="font-semibold">Amount:</span>
                        <span>{requisition.amount}</span>
                    </div>

                    <div className="flex items-center gap-3">
                        <FaBuilding className="text-orange-500" />
                        <span className="font-semibold">Department:</span>
                        <span>{requisition.department}</span>
                    </div>

                    <div className="flex items-center gap-3">
                        <FaCalendarAlt className="text-orange-500" />
                        <span className="font-semibold">Date:</span>
                        <span>{new Date(requisition.createdAt).toLocaleDateString()}</span>
                    </div>

                    <div className="flex items-center gap-3">
                        <FaInfoCircle className="text-orange-500" />
                        <span className="font-semibold">Status:</span>
                        <span className={`px-2 py-1 text-xs font-semibold rounded-full ${requisition.status === "Approved" ? "bg-green-100 text-green-700" : requisition.status === "Rejected" ? "bg-red-100 text-red-700" : "bg-yellow-100 text-yellow-700"}`}>
                            {requisition.status}
                        </span>
                    </div>
                    
                    {requisition.purpose && (
                        <div>
                            <span className="font-semibold block text-sm mb-1">Purpose:</span>
                            <p className="border border-gray-200 rounded-md p-3 bg-gray-50 text-gray-800 text-sm">{requisition.purpose}</p>
                        </div>
                    )}
                </div>
                
                <div className="mt-6 flex justify-end">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 text-sm font-medium text-white bg-orange-600 rounded-md hover:bg-orange-700 transition-colors"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ViewRequisitionModal;